module.exports = __webpack_public_path__ + "static/media/kosice.c1c00221.jpg";